import { MiniGameConfig, MiniGameType } from '../interfaces/mini-game.interface';

export const MINI_GAME_CONFIGS: MiniGameConfig[] = [
  {
    type: MiniGameType.CLASSIC_QUIZ,
    name: { en: 'Classic Quiz', ar: 'اختبار كلاسيكي' },
    description: { en: 'Answer questions one by one', ar: 'أجب على الأسئلة واحداً تلو الآخر' },
    icon: '&#128218;',
    color: '#4CAF50',
    questionsCount: 7,
    timePerQuestion: 30,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.SPIN_WHEEL,
    name: { en: 'Spin the Wheel', ar: 'أدر العجلة' },
    description: { en: 'Spin to pick who answers!', ar: 'أدر لاختيار من يجيب!' },
    icon: '&#127905;',
    color: '#FF9800',
    questionsCount: 7,
    timePerQuestion: 30,
    requiresStudents: true,
    minStudents: 4,
    xpMultiplier: 1.25
  },
  {
    type: MiniGameType.TUG_OF_WAR,
    name: { en: 'Tug of War', ar: 'شد الحبل' },
    description: { en: 'Two teams, one rope!', ar: 'فريقان، حبل واحد!' },
    icon: '&#129351;',
    color: '#F44336',
    questionsCount: 20,
    timePerQuestion: 25,
    requiresStudents: true,
    minStudents: 4,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.LIGHTNING_ROUND,
    name: { en: 'Lightning Round', ar: 'الجولة الخاطفة' },
    description: { en: 'Fast questions, big combos!', ar: 'أسئلة سريعة، مضاعفات كبيرة!' },
    icon: '&#9889;',
    color: '#FFC107',
    questionsCount: 12,
    timePerQuestion: 10,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.BOMB_PASS,
    name: { en: 'Bomb Pass', ar: 'تمرير القنبلة' },
    description: { en: 'Answer before it explodes!', ar: 'أجب قبل أن تنفجر!' },
    icon: '&#128163;',
    color: '#E91E63',
    questionsCount: 10,
    timePerQuestion: 0, // random 8-15s per question
    requiresStudents: true,
    minStudents: 4,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.MYSTERY_BOX,
    name: { en: 'Mystery Box', ar: 'الصندوق الغامض' },
    description: { en: 'Surprises in every box!', ar: 'مفاجآت في كل صندوق!' },
    icon: '&#127873;',
    color: '#9C27B0',
    questionsCount: 8,
    timePerQuestion: 30,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.BOWLING,
    name: { en: 'Strike Lane', ar: 'مضمار البولينج' },
    description: { en: 'Aim, power up, knock them all down', ar: 'صوّب، اشحن القوة، أسقطهم جميعاً' },
    icon: '&#127923;',
    color: '#3F51B5',
    questionsCount: 0,
    timePerQuestion: 0,
    requiresStudents: true,
    minStudents: 2,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.SYMMETRY,
    name: { en: 'Mirror Match', ar: 'مطابقة المرآة' },
    description: { en: 'Slide the mirror to find a line of symmetry', ar: 'حرّك المرآة لتجد خط التماثل' },
    icon: '&#128311;', // 🔷
    color: '#7E57C2',
    questionsCount: 10, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.MATCH_UP,
    name: { en: 'Star Match', ar: 'مطابقة النجوم' },
    description: { en: 'Match numbers to dots, dice, ten-frames and sums', ar: 'طابِق الأرقام مع النقاط والنرد والجمع' },
    icon: '&#127775;', // 🌟
    color: '#5C6BC0',
    questionsCount: 10, // rounds (two full mode cycles)
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.FRACTION_LINE,
    name: { en: 'Fraction Blast', ar: 'انطلاق الكسور' },
    description: { en: 'Launch the rocket to a fraction on the number line', ar: 'أطلق الصاروخ إلى الكسر على خط الأعداد' },
    icon: '&#128640;', // 🚀
    color: '#FF7043',
    questionsCount: 9, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.FRACTION_HOPS,
    name: { en: 'Fraction Hops', ar: 'قفزات الكسور' },
    description: { en: 'Jump a fraction over and over to multiply', ar: 'اقفز الكسر مرارًا لتضرب' },
    icon: '&#128056;', // 🐸
    color: '#66BB6A',
    questionsCount: 8, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.FRACTION_TREK,
    name: { en: 'Fraction Trek', ar: 'مسير الكسور' },
    description: { en: 'Add and subtract fractions on a number line', ar: 'اجمع واطرح الكسور على خط الأعداد' },
    icon: '&#129517;', // 🧭
    color: '#26A69A',
    questionsCount: 8, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.ZOOM_QUEST,
    name: { en: 'Zoom Quest', ar: 'رحلة التكبير' },
    description: { en: 'Zoom the number line to pinpoint a number by place value', ar: 'كبّر خط الأعداد لتحديد رقم حسب القيمة المكانية' },
    icon: '&#128269;', // 🔍
    color: '#F4A825',
    questionsCount: 6, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.TREASURE_GRID,
    name: { en: 'Treasure Grid', ar: 'شبكة الكنز' },
    description: { en: 'Plot ordered pairs on a coordinate grid to dig up treasure', ar: 'حدد الأزواج المرتبة على شبكة الإحداثيات للعثور على الكنز' },
    icon: '&#128506;', // 🗺️
    color: '#2FA98C',
    questionsCount: 8, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.CUBE_FILL,
    name: { en: 'Cube Fill', ar: 'ملء المكعبات' },
    description: { en: 'Measure a prism\'s cubic volume and pour to fill the tank', ar: 'قِس الحجم المكعب للمنشور واسكب لملء الحوض' },
    icon: '&#129482;', // 🧊
    color: '#2E9BE6',
    questionsCount: 8, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.BALANCE_IT,
    name: { en: 'Balance It', ar: 'وازِن الميزان' },
    description: { en: 'Convert metric units and balance the scale', ar: 'حوّل الوحدات المترية ووازِن الميزان' },
    icon: '&#9878;', // ⚖️
    color: '#37C8B3',
    questionsCount: 8, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.POWER_BURST,
    name: { en: 'Power Burst', ar: 'انفجار القوة' },
    description: { en: 'Evaluate exponents and detonate the chain reaction', ar: 'احسب الأس وفجّر التفاعل المتسلسل' },
    icon: '&#128165;', // 💥
    color: '#7C5CFF',
    questionsCount: 8, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.CUTTING_PIZZA,
    name: { en: 'Cutting Pizza', ar: 'تقطيع البيتزا' },
    description: { en: 'Cut pizza slices to add and subtract fractions', ar: 'قطّع شرائح البيتزا لجمع وطرح الكسور' },
    icon: '&#127829;', // 🍕
    color: '#F04438',
    questionsCount: 8, // rounds
    timePerQuestion: 0,
    requiresStudents: false,
    minStudents: 0,
    xpMultiplier: 1.0
  },
  {
    type: MiniGameType.VAULT_CRACKER,
    name: { en: 'Vault Cracker', ar: 'خزنة النِّسَب' },
    description: { en: 'Turn the safe dial to find the percent of a quantity', ar: 'أدِر قرص الخزنة لتجد النسبة المئوية من كمية' },
    icon: '&#128272;', // 🔐
    color: '#B08D2E',
    questionsCount: 7, // rounds
    timePerQuestion: 0,
    requiresStudents: true,
    minStudents: 0,
    xpMultiplier: 1.0
  }
];

export function getMiniGameConfig(type: MiniGameType): MiniGameConfig {
  return MINI_GAME_CONFIGS.find(c => c.type === type)!;
}
